import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, CircularProgress, Typography } from '@mui/material';
import { useRole } from '../hooks/useRole';

/**
 * Dashboard component that redirects users to their role-specific layout
 * This acts as a router based on the user's role
 */
const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { role, loading } = useRole();

  useEffect(() => {
    if (!loading && role) {
      // Redirect to role-specific dashboard
      switch (role) {
        case 'admin':
          navigate('/admin/dashboard', { replace: true });
          break;
        case 'school_admin':
          navigate('/school-admin/dashboard', { replace: true });
          break;
        case 'teacher':
          navigate('/teacher/dashboard', { replace: true });
          break;
        case 'student':
          navigate('/student/dashboard', { replace: true });
          break;
        default:
          // If role is not recognized, show error
          console.error('Unknown role:', role);
          navigate('/unauthorized', { replace: true });
      }
    }
  }, [role, loading, navigate]);

  // Show loading while determining role
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="body1" color="text.secondary">
          Loading your dashboard...
        </Typography>
      </Box>
    </Container>
  );
};

export default Dashboard;
